/**
 * @generated SignedSource<<9fa3f8941d05bec61e43ba11bff8f8c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingHeader_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Attendees_viewer" | "JoinConferenceButton_viewer" | "MoreActionsMenu_MeetingHeader_viewer" | "SeriesSwitcher_viewer">;
  readonly " $fragmentType": "MeetingHeader_viewer";
};
export type MeetingHeader_viewer$key = {
  readonly " $data"?: MeetingHeader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingHeader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingHeader_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SeriesSwitcher_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JoinConferenceButton_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Attendees_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MoreActionsMenu_MeetingHeader_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ed4001bef8300b8cb18841510650822f";

export default node;
